import { useState, useEffect, useRef } from "react";
import Button from "react-bootstrap/Button";
import Badge from "react-bootstrap/Badge";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import Table from "react-bootstrap/Table";
import WmInvoiceForm from "./InvoiceForm";
import WmInvoiceSummary from "./InvoiceSummary";
import WmAddressForm from "./AddressForm";
import WmWorkListAcrdn from "../worksheet/WmeterList";
import OtherWorkListAcrdn from "../worksheet/InvitemList";
import WorkSheetPhoto from "../worksheet/WorkSheetPhoto";
import { showBackendError } from "./ShowError";
import ReactModal from "react-modal";
import { backendErrorMessage } from "../shared/backendError";
import { ControlButtons } from "./ControlButtons";
import { toast } from "react-toastify";
import { SignatureBrief } from "./TakeSignature";
import Form from "react-bootstrap/Form";
import { userStatus, apiURL, showConfirmationDialog, GetAnyList, GetImage } from "./WmUtils";
import { upLoadWorkSheet } from "../worksheet/upLoadWorksheet";
import { WorkSheetForm } from "../worksheet/WorksheetForm";
import useTaskDetailsFormControlStore, { SAVE_WORKSHEET, SAVE_SIGNED_WORKSHEET, SAVE_AND_SEND_WORKSHEET, SAVE_AND_NEXT_TO_INVOICING } from "../stores/TaskDetailsFormControlStore";
import useOMEContentStore from "../stores/useOMEContentStore.jsx";
import useInvoiceStatusStore from "../stores/useInvoiceStatusStore.jsx";
import { formatSealWatermeterId } from './WmUtils';
import { ButtonLoader } from "./ButtonLoader.jsx"
import useTaskStore from "../stores/useTaskStore.jsx";

import * as types from "../shared/types";
import useSettingsStore from "../stores/SettingsStore.jsx";

const taskURL = apiURL + "/tasks";

// OnlineOrderPhoto.source labels (backend Task 1) — kept local to this
// component, mirroring wm_frontend/src/containers/WorkForm.js.
const ORDER_PHOTO_SOURCE_LABELS = {
  customer: "Ügyfél",
  dispatcher: "Diszpécser",
};

// Exported for testing. A freshly constructed Vízóra row must never start in
// a state that already violates the backend's wm_meter_id_or_meter_not_ok /
// wm_plomba1_id_or_plomba1_not_ok DB CheckConstraints (enforced via
// Wmeter.clean(), see WmSerializer): "Ép" (true) requires a non-empty
// identifier, so a row built with an empty identifier must start as
// "Hiányzik" (null) instead of "Ép" (true). See issue #377.
export const deriveInitialOkStatus = (identifier) => (identifier ? true : null);

/*eslint-disable eqeqeq*/
const DetailedTask = (props) => {
  const childRef = useRef();
  const [propState, setPropState] = useState(props);
  const [activeKey, setActiveKey] = useState(null);
  const [activeWmTabKey, setActiveWmTabKey] = useState(0);
  const [initialLoading, setInitialLoading] = useState(true);
  const [overAllAcrdActiveKey, setOverAllAcrdActiveKey] = useState("1");
  const [workSheetPhotoItemSerial, setWorkSheetPhotoItemSerial] = useState(null);
  const [focusRefKey, setFocusRefKey] = useState(null);
  const [addressFormValidated, setAddressFormValidated] = useState(true);
  const [invoiceFormValidated, setInvoiceFormValidated] = useState(true);
  const { content, setContent } = useOMEContentStore((state) => ({ content: state.content, setContent: state.setContent }));
  const { setInvoiceStatus } = useInvoiceStatusStore((state) => ({ invoiceStatus: state.invoiceStatus, setInvoiceStatus: state.setInvoiceStatus }));
  const [isAnySavedWaterMeterExists, setIsAnySavedWaterMeterExists] = useState(false);
  const [orderPhotos, setOrderPhotos] = useState([]);
  const [orderPhotoBlobUrls, setOrderPhotoBlobUrls] = useState([]);
  const [orderPhotosLoading, setOrderPhotosLoading] = useState(false);
  const { taskId, setTaskId, setTaskList, taskList, selectedTask, updateSelected, addressData, setAddressData } = useTaskStore();

  const { isButtonDisabled, setIsButtonDisabled, loading, setLoading, loadingTarget, setLoadingTarget } = useTaskDetailsFormControlStore((state) => ({
    isButtonDisabled: state.isButtonDisabled,
    setIsButtonDisabled: state.setIsButtonDisabled,
    loading: state.loading,
    setLoading: state.setLoading,
    loadingTarget: state.loadingTarget,
    setLoadingTarget: state.setLoadingTarget,
  }));
  const { settings } = useSettingsStore();

  /// To elmininate 'Warning: Can't perform a React state update on an unmounted component...'
  const isMountedComponent = useRef(true);
  const focusRefList = useRef({});
  const emailRef = useRef();
  const mechanicNoteRef = useRef();
  const mechanicNoteToCustomerRef = useRef();
  const workplaceToBeStandardizedRef = useRef();
  

  useEffect(() => {
    setIsButtonDisabled(props.actTaskState?.key !== "STARTED");
  }, [taskId, props.actTaskState]);

  //this useEffect is needed, because in this form there are several propState.SetXXX calls.
  //   These calls are setting the new state in the caller Form's state. Not in this form, because the useState is defined there, and not in this form.
  //   After changing the caller Form's state this [props] event fires and refreshes all the states also in this form (therefore the rendering will also run).
  useEffect(() => {
    setPropState(props);
  }, [props]);

  useEffect(() => {
    if (!taskId) { setOrderPhotos([]); setOrderPhotoBlobUrls([]); return; }
    GetAnyList(`${apiURL}/tasks/${taskId}/online-order-photos/`)
      .then(resp => {
        setOrderPhotos(resp?.data?.photos || []);
        setOrderPhotoBlobUrls([]);
      })
      .catch(() => setOrderPhotos([]));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taskId]);

  useEffect(() => {
    if (overAllAcrdActiveKey !== "order_photos" || orderPhotos.length === 0 || orderPhotoBlobUrls.length > 0) return;
    setOrderPhotosLoading(true);
    Promise.all(orderPhotos.map(p => GetImage(`${apiURL}/tasks/${taskId}/online-order-photos/${p.filename}`)
      .then(r => (r?.data ? { url: URL.createObjectURL(r.data), source: p.source } : null))))
      .then(results => {
        setOrderPhotoBlobUrls(results.filter(Boolean));
        setOrderPhotosLoading(false);
      })
      .catch(() => {
        setOrderPhotosLoading(false);
        toast.error('Képek betöltése nem sikerült.');
      });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [overAllAcrdActiveKey]);

  useEffect(() => {
    if (!!focusRefKey && !!focusRefList) {
      (async function () {
        if (focusRefKey !== "nullfocus") {
          focusRefList.current[focusRefKey].scrollIntoView({ behavior: "smooth" });
        }
      })();
    }
  }, [focusRefKey]);

  useEffect(async () => {
    if (isMountedComponent.current) {
      if (propState.comStat === userStatus.ok) {
        setInvoiceStatus(await getInvoiceStatus());
        setInitialLoading(false);
        const isAnySaved = checkIfWmWorkListSaved();
        setIsAnySavedWaterMeterExists(isAnySaved);
      } else {
        setInitialLoading(false);
      }
    }
    return () => {
      isMountedComponent.current = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getInvoiceStatus = async () => {
    const invoiceStatusRetVal = await GetAnyList(`${apiURL}/tasks/${taskId}/`);
    if (invoiceStatusRetVal?.status === 200) {
      return invoiceStatusRetVal.data.invoice_status;
    }
  };

  useEffect(() => {
    let photoItemIndex = undefined;
    if (overAllAcrdActiveKey === "2" && activeKey === null) {
      propState.otherWorkList[`${taskId}`]?.wmlist?.some((fii, iii) => {
        if (fii.price == types.INVOICE_ITEM_EXTREM_PRICE) {
          photoItemIndex = iii;
          return true;
        }
        return false;
      });
      if (photoItemIndex !== undefined) {
        if (workSheetPhotoItemSerial != photoItemIndex) setWorkSheetPhotoItemSerial(photoItemIndex);
      } else {
        insertNewOther(true /** isPhoto */);
      }
    }
    if (overAllAcrdActiveKey !== "2") {
      if (workSheetPhotoItemSerial !== null) setWorkSheetPhotoItemSerial(null);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [overAllAcrdActiveKey, activeKey, propState.otherWorkList]);

  useEffect(() => {
    if (content && content.task_id === taskId) {
      const actAddressData = {
        contact_name: findSingleTextValueByViewID(content.descriptors, "identification_nameEt"),
        contact_phone: addressData.contact_phone,
        contact_email: addressData.contact_email,
        address_country: addressData.address_country,
        address_postal_code: findSingleTextValueByViewID(content.descriptors, "identification_zipEt"),
        address_city: findSingleTextValueByViewID(content.descriptors, "identification_cityEt").split(" ")[0],
        address_route: findSingleTextValueByViewID(content.descriptors, "identification_streetEt"),
        address_street_number: findSingleTextValueByViewID(content.descriptors, "identification_house_numberEt"),
        address_building: findSingleTextValueByViewID(content.descriptors, "identification_buildingEt"),
        address_floor: findSingleTextValueByViewID(content.descriptors, "identification_stairwayEt"),
        address_door: findSingleTextValueByViewID(content.descriptors, "identification_floorEt"),
        address_doorbell: findSingleTextValueByViewID(content.descriptors, "identification_doorEt"),
      };
      setAddressData(actAddressData);
      propState.updateWorkAndInvoice(actAddressData);
      if (overAllAcrdActiveKey === "0") {
        childRef.current.loadAddressData(actAddressData);
      }
    }
  }, [content]);

  useEffect(() => {
    let numOfFelszereles = 0;
    if (content && content.workItems) {
      let newWmWorkList = [];
      content?.workItems.forEach((workItem, index) => {
        const hasEquipment = workItem.some((descriptor) => descriptor.viewID === "caption" && descriptor.textValue === "Felszerelés");
        if (hasEquipment && content && content.task_id === taskId) {
          numOfFelszereles++;
          newWmWorkList = setOMEWorkItems(workItem, newWmWorkList, numOfFelszereles);
        }
      });
      propState.SetWmWorkList(newWmWorkList);
    }
  }, [content]);

  const checkIfWmWorkListSaved = () => {
    const wmWorkList = props.wmWorkList[taskId];
    return wmWorkList?.wmlist?.some((item) => item.id !== null); // watermeters that are not saved in db doesn't have id
  };

  useEffect(() => {
    const isAnySaved = checkIfWmWorkListSaved();
    setIsAnySavedWaterMeterExists(isAnySaved);
  }, [props.wmWorkList, taskId]);

  const handleTakeOverCustomerTypeChange = (event) => { 
    const selectedValue = event.target.value;
    selectedTask.task_takeover_customer_type = selectedValue;
    updateSelected();
  };
  const setOMEWorkItems = (workItem, wmWorkList, numOfFelszereles) => {
    let newState = Object.assign({}, wmWorkList);
    let task = newState[`${taskId}`];
    let newWmNumber = null;
    if (task && task.wmlist && task.wmlist.length > 0) {
      const lastWMnumber = Math.max.apply(
        Math,
        task.wmlist.map((item) => item.wm_number)
      );
      newWmNumber = lastWMnumber + 1;
    } else {
      newWmNumber = 0;
    }

    const oldMeterIdentifier =
      numOfFelszereles === 1 ? formatSealWatermeterId(findTextValuesByViewID(content.workItems, "dismount_data_serialNumberTv")[newWmNumber] || "") : "";
    const oldPlomba1Identifier = "";

    const initialWaterMeterDatas = {
      id: null,
      version: null,
      is_new: false,
      watermeter_physical_place: selectedTask.work_watermeter_physical_place || "",
      size: 15,
      meter_length_in_mm: 110,
      meter_valid_from: new Date().getFullYear()-8,
      meter_model: "MOM", 
      meter_is_transmitter_supported: true,
      meter_ok: deriveInitialOkStatus(oldMeterIdentifier),
      act_meter: findTextValuesByViewID(content.workItems, "dismount_data_dismount_measurer_stateEt")[newWmNumber] || 0,
      meter_identifier: oldMeterIdentifier,
      plomba1_identifier: oldPlomba1Identifier,
      plomba1_ok: deriveInitialOkStatus(oldPlomba1Identifier),
      plomba2_identifier: "",
      plomba2_ok: deriveInitialOkStatus(""),
      images: [],
      note: "",
      t_id: taskId,
      wm_number: newWmNumber,
      wm_note: "",
    };

    const newMeterIdentifier = formatSealWatermeterId(findTextValuesByViewID(content.workItems, "mount_serial_numberEt")[newWmNumber] || "");
    const newPlomba1Identifier = formatSealWatermeterId(findTextValuesByViewID(content.workItems, "mount_closing_element_numberEt")[newWmNumber] || "");

    const updatedWaterMeterDatas = {
      ...initialWaterMeterDatas,
      is_new: true,
      meter_valid_from: new Date().getFullYear(),
      is_cold: findTextValueIsColdByViewID(workItem, "mount_device_type_coldRb", "mount_device_type_warmRb"),
      size: findTextValuesByViewID(content.workItems, "Mérő mérete")[newWmNumber] || 15,
      act_meter: findTextValuesByViewID(content.workItems, "mount_measurer_valueEt")[newWmNumber] || 0,
      meter_identifier: newMeterIdentifier,
      meter_ok: deriveInitialOkStatus(newMeterIdentifier),
      plomba1_identifier: newPlomba1Identifier,
      plomba1_ok: deriveInitialOkStatus(newPlomba1Identifier),
    };

    if (newState[`${taskId}`]) {
      if (newState[`${taskId}`]["imgSerial"]) {
      } else {
        newState[`${taskId}`]["imgSerial"] = 1;
      }
    } else {
      newState[`${taskId}`] = { imgSerial: 1, wmlist: [] };
    }
    const tempList = newState[`${taskId}`]["wmlist"]
      ? [...newState[`${taskId}`].wmlist, initialWaterMeterDatas, updatedWaterMeterDatas]
      : [initialWaterMeterDatas, updatedWaterMeterDatas];

    newState[`${taskId}`]["wmlist"] = tempList;
    return newState;
  };

  const findTextValuesByViewID = (content, viewID) => {
    const result = content
      .flat()
      .filter((element) => element.viewID === viewID)
      .map((element) => element?.textValue);
    return result;
  };

  const findTextValueIsColdByViewID = (workItem, coldId, warmId) => {
    let result = !(workItem.find((element) => element.viewID === warmId)?.textValue === "true");
    result = workItem.find((element) => element.viewID === coldId)?.textValue === "true";
    return result;
  };

  const findSingleTextValueByViewID = (content, viewID) => {
    const result = content.flat().find((element) => element.viewID === viewID)?.textValue;
    return result;
  };

  const addNewWatermeter = async (event) => {
    event.preventDefault();
    let newState = Object.assign({}, propState.wmWorkList);
    let task = newState[`${taskId}`];
    let newWmNumber = null;
    if (task && task.wmlist && task.wmlist.length > 0) {
      const lastWMnumber = Math.max.apply(
        Math,
        task.wmlist.map((item) => item.wm_number)
      );
      newWmNumber = lastWMnumber + 1;
    } else {
      newWmNumber = 0;
    }

    const initialOldWaterMeter = {
      id: null,
      version: null,
      is_new: false,
      is_cold: null,
      watermeter_physical_place: "",
      size: 15,
      meter_length_in_mm: 110,
      meter_valid_from: new Date().getFullYear()-8,
      meter_model: "MOM", 
      meter_is_transmitter_supported: true,
      meter_ok: deriveInitialOkStatus(""),
      act_meter: 0,
      meter_identifier: "",
      plomba1_identifier: "",
      plomba1_ok: deriveInitialOkStatus(""),
      plomba2_identifier: "",
      plomba2_ok: deriveInitialOkStatus(""),
      images: [],
      note: "",
      t_id: taskId,
      wm_number: newWmNumber,
      wm_note: "",
    };

    const initialNewWaterMeter = {
      ...initialOldWaterMeter,
      is_new: true,
      meter_valid_from: new Date().getFullYear(),
    };

    if (newState[`${taskId}`]) {
      if (newState[`${taskId}`]["imgSerial"]) {
      } else {
        newState[`${taskId}`]["imgSerial"] = 1;
      }
    } else {
      newState[`${taskId}`] = { imgSerial: 1, wmlist: [] };
    }
    const tempList = newState[`${taskId}`]["wmlist"]
      ? [...newState[`${taskId}`].wmlist, initialOldWaterMeter, initialNewWaterMeter]
      : [initialOldWaterMeter, initialNewWaterMeter];

    newState[`${taskId}`]["wmlist"] = tempList;
    propState.SetWmWorkList(newState);
  };

  const insertNewOther = (isPhoto = false) => {
    const tempVar = {
      id: null,
      version: null,
      description: isPhoto ? `Munkalap ${new Date().toLocaleString("hu", { timeZone: "Europe/Budapest" })}` : "",
      price: isPhoto ? types.INVOICE_ITEM_EXTREM_PRICE : 0,
      images: [],
      note: "",
      t_id: taskId,
    };

    let newState = Object.assign({}, propState.otherWorkList);
    if (newState[`${taskId}`]) {
      if (newState[`${taskId}`]["imgSerial"]) {
      } else {
        newState[`${taskId}`]["imgSerial"] = 1;
      }
    } else {
      newState[`${taskId}`] = { imgSerial: 1, wmlist: [] };
    }
    const tempList = newState[`${taskId}`]["wmlist"] ? [...newState[`${taskId}`].wmlist, tempVar] : [tempVar];
    newState[`${taskId}`]["wmlist"] = tempList;
    propState.SetOtherWorkList(newState);
  };

  const addNewOtherWork = async (event) => {
    event.preventDefault();
    insertNewOther();
  };

  const saveWorkSheetWithLoader = async (targetID, onSuccess) => {
    console.info("Saving worksheet", { taskId, targetID });
    setLoading(true);
    setLoadingTarget(targetID);
    try {
      if (mechanicNoteToCustomerRef.current)
        selectedTask.task_note_mech_to_customer = mechanicNoteToCustomerRef.current.value;
      
      if (workplaceToBeStandardizedRef.current)
        selectedTask.workplace_to_be_standardized = workplaceToBeStandardizedRef.current.checked;

      return await upLoadWorkSheet(taskId, selectedTask, propState,
        async () => {
          console.info("Worksheet saved successfully", { taskId, targetID });
          await onSuccess();
          setLoading(false);
          setLoadingTarget("");
        }
      );
    } catch (error) {
      console.error("Failed to save worksheet", {
        taskId,
        targetID,
        error
      });
      throw error;
    } finally {
      setLoading(false);
      setLoadingTarget("");
    }
  }
  const onSaveWorkSheet = async (targetID) => await saveWorkSheetWithLoader(targetID, () => setOverAllAcrdActiveKey(null));

  const overAllAccOnSelect = (evt) => {
    setOverAllAcrdActiveKey(evt);
    if (evt !== "1") {
      setActiveKey(null);
    }
  };

  const onClickCloseDetails = () => {
    console.log("User attempting to close task details", { taskId });
    showConfirmationDialog("Biztos, hogy ki akar lépni? A nem mentett adatok elveszhetnek.", "Részletőző bezárása", (res) => onCloseDetails(res));
  };
  const onCloseDetails = (result) => {
    if (result === types.MESSAGEBOX_RESPONSE_YES) {
      console.info("Task details closed", { taskId });
      setTaskId(null);
      setContent(null);
    } else {
      console.log("Task details close cancelled", { taskId });
    }
  };

  const emailWorksheet = async () => {
    console.info("Sending worksheet via email", { taskId });
    const emailRetVal = await GetAnyList(taskURL + `/${taskId}/mailworksheet/`);
    if (emailRetVal?.status === 200) {
      if (emailRetVal.data[0].status == "true") {
        console.info("Worksheet email sent successfully", { taskId });
        toast.info(emailRetVal.data[0].body);
      } else {
        console.warn("Worksheet email sent with warnings", {
          taskId,
          message: emailRetVal.data[0].body
        });
        toast.warning(emailRetVal.data[0].body);
      }
    } else {
      console.error("Failed to send worksheet email", {
        taskId,
        status: emailRetVal?.status,
        error: emailRetVal?.data
      });
      if (emailRetVal?.status === 403) {
        propState.SetComStat(userStatus.unautorized);
      } else {
        propState.SetComStat(userStatus.offline);
      }
      showBackendError(backendErrorMessage("Hiba a munkalap küldésekor: ", emailRetVal.data[0].body));
      return;
    }
  };

  const InvoiceAccordionDisabled = () => {
    if (propState.actTaskState === propState.taskStateList.STARTED || propState.actTaskState === propState.taskStateList.SCHEDULED) {
      setOverAllAcrdActiveKey();
      toast.error("Kérlek zárd le a munkát számlázás előtt");
    }
  };

  const onSaveAndSendWorkSheet = () => {
    if (propState.comStat === userStatus.offline) {
      console.warn("Cannot send worksheet email - application offline", { taskId });
      toast.warning(
        <div>
          Az alkalmazás offline állapontban van,
          <br /> nem lehetséges az email küldés
        </div>
      );
      return;
    }
    if (emailRef.current.value == null || emailRef.current.value == "") {
      console.warn("Cannot send worksheet - email address missing", { taskId });
      toast.error("Kérlek töltsd ki az email címet!");
      return;
    }
    console.info("Saving and sending worksheet", {
      taskId,
      email: emailRef.current.value
    });
    let newAddressData = Object.assign({}, addressData);
    newAddressData.contact_email = emailRef.current.value;
    setAddressData(newAddressData);
    propState.updateWorkAndInvoice(newAddressData);
    saveWorkSheetWithLoader(SAVE_AND_SEND_WORKSHEET, async () => await emailWorksheet());
  };

  const onSaveAndInvoice = () => {
    console.info("Saving worksheet and moving to invoicing", { taskId });
    selectedTask.task_note_mech_to_disp = mechanicNoteRef.current.value;
    let newAddressData = Object.assign({}, addressData);
    newAddressData.contact_email = emailRef.current.value;
    setAddressData(newAddressData);
    propState.updateWorkAndInvoice(newAddressData);
    setTaskList(taskList);
    saveWorkSheetWithLoader(SAVE_AND_NEXT_TO_INVOICING, () => setOverAllAcrdActiveKey("3"));
  };

  const printWorkSheet = async () => {
    console.info("Downloading worksheet PDF", { taskId });
    const printRetVal = await GetAnyList(taskURL + `/${taskId}/worksheet/`, true /* isPdf */);
    if (printRetVal?.status === 200) {
      console.info("Worksheet PDF downloaded successfully", { taskId });
      const pdfUrl = URL.createObjectURL(printRetVal.data);
      let link = document.createElement("a");
      link.href = pdfUrl;
      link.download = `munkalap${taskId}.pdf`;
      link.click();
    } else {
      console.error("Failed to download worksheet PDF", {
        taskId,
        status: printRetVal?.status
      });
      if (printRetVal?.status === 403) {
        propState.SetComStat(userStatus.unautorized);
      } else {
        propState.SetComStat(userStatus.offline);
      }
      showBackendError(backendErrorMessage("Hiba a munkalap letöltésekor: ", printRetVal));
      return;
    }
  };

  const printWorkSheet80mm = async () => {
    console.info("Downloading 80mm worksheet PDF", { taskId });
    const printRetVal = await GetAnyList(taskURL + `/${taskId}/worksheet80mm/`, true /* isPdf */);
    if (printRetVal?.status === 200) {
      console.info("80mm worksheet PDF downloaded successfully", { taskId });
      const pdfUrl = URL.createObjectURL(printRetVal.data);
      let link = document.createElement("a");
      link.href = pdfUrl;
      link.download = `munkalap80mm${taskId}.pdf`;
      link.click();
    } else {
      console.error("Failed to download 80mm worksheet PDF", {
        taskId,
        status: printRetVal?.status
      });
      if (printRetVal?.status === 403) {
        propState.SetComStat(userStatus.unautorized);
      } else {
        propState.SetComStat(userStatus.offline);
      }
      showBackendError(backendErrorMessage("Hiba a 80mm munkalap letöltésekor: ", printRetVal));
    }
  };

  const onSetActiveKey = (event) => {
    setActiveKey(event);
    //This function is neccessary to refresh tabs according to old and new watermeters on the watermeter accordions active sheet.
    if (
      event &&
      propState.wmWorkList[`${taskId}`] !== undefined &&
      propState.wmWorkList[`${taskId}`].wmlist.filter((item) => item.wm_number == event)[0] !== undefined
    ) {
      setActiveWmTabKey(propState.wmWorkList[`${taskId}`].wmlist.filter((item) => item.wm_number == event)[0].is_new);
    }
    function delayedSetFocusRefKey() {
      setFocusRefKey(`${event}focus`);
    }
    setTimeout(delayedSetFocusRefKey, 500);
  };

  return (
    <>
      {initialLoading ? (
        <ReactModal
          isOpen={initialLoading}
          appElement={document.getElementById("root")}
          style={{
            width: "100%",
            height: "100%",
            margin: "0",
            padding: "0",
            dialog: {
              width: "100%",
              height: "100%",
              margin: "0",
              padding: "0",
            },
            content: {
              width: "100%",
              height: "auto",
              minHeight: "100%",
              inset: "0",
              borderRadius: "0",
              margin: "0",
              padding: "0",
            },
            // transform: 'translate(-50%, -50%)'
          }}
          contentLabel="Photo Modal"
        >
          <div
            style={{
              position: "absolute",
              left: "50%",
              top: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
            Adatok betöltése...
          </div>
        </ReactModal>
      ) : (
        <>
          <table width="100%">
            <tbody>
              <tr>
                <td>
                  <Badge pill variant={propState.actTaskState.variant}>
                    {" "}
                    {propState.actTaskState.name}
                  </Badge>
                </td>
                <td style={{ textAlign: "center" }}>
                  <Badge variant="info" size="sm">
                    {selectedTask.task_no}
                    <br></br>
                    {selectedTask.work_no}
                  </Badge>
                </td>
                <td style={{ textAlign: "right" }}>
                  <div style={{ textAlign: "right" }}>
                    <Button className=" px-1 py-0" variant="outline-dark" onClick={onClickCloseDetails}>
                      <h4 className="px-1 my-0 py-0">×</h4>
                    </Button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <ControlButtons
            actTaskState={propState.actTaskState}
            SetActTaskState={(newState) => {
              propState.SetActTaskState(newState);
              setIsButtonDisabled(newState.key !== "STARTED");
            }}
            comStat={propState.comStat}
            actTask={taskId}
            taskList={taskList}
            taskStateList={propState.taskStateList}
            setOverAllAcrdActiveKey={setOverAllAcrdActiveKey}
            onSaveWorkSheet={(buttonTargetID, onSuccess) => saveWorkSheetWithLoader(buttonTargetID, async () => await onSuccess())}
            showOMEFileButton={true}
            disallowOMELoad={isAnySavedWaterMeterExists || isButtonDisabled}
            waterMeterList={propState.wmWorkList[`${taskId}`]?.wmlist}
          />

          <Accordion defaultActiveKey={overAllAcrdActiveKey} activeKey={overAllAcrdActiveKey} onSelect={overAllAccOnSelect} width="100%" className="mx-0 px-0">
            <Card id="address_card">
              <Card.Header style={{ textAlign: "center", backgroundColor: addressFormValidated ? "#003399" : "red" }}>
                <Accordion.Toggle as={Button} variant="link" eventKey="0">
                  <h4 style={{ color: "#66ffff" }}>Cím</h4>
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey="0">
                <Card.Body>
                  {overAllAcrdActiveKey === "0" && (
                    <>
                      <Table responsive>
                        <tbody>
                          <tr>
                            <td>{selectedTask.work_contact_name}</td>
                          </tr>
                          <tr>
                            <td>{selectedTask.work_contact_phone}</td>
                          </tr>
                          <tr>
                            <td>
                              {addressData.address_city + ","} {addressData.address_route + " "} {addressData.address_street_number + ","}{" "}
                              {addressData.address_building ? "épület" + " " + addressData.address_building + " " : ""}
                              {addressData.address_floor ? "emelet" + " " + addressData.address_floor + " " : ""}
                              {addressData.address_door ? "ajtó" + " " + addressData.address_door : ""}
                              &nbsp;{addressData.address_postal_code + " "} {addressData.address_country}
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <h5 style={{ color: "aqua", textAlign: "center" }}>Cím részletek</h5>
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                      <WmAddressForm
                        className="webAddressForm1234"
                        updateWorkAndInvoice={propState.updateWorkAndInvoice}
                        setAddressFormValidated={setAddressFormValidated}
                        onSave={(buttonTargetID) => saveWorkSheetWithLoader(buttonTargetID, () => setOverAllAcrdActiveKey("1"))}
                        ref={childRef}
                      />
                    </>
                  )}
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            {orderPhotos.length > 0 && (
              <Card id="order_photos_card">
                <Card.Header style={{ textAlign: "center", backgroundColor: "#003399" }}>
                  <Accordion.Toggle as={Button} variant="link" eventKey="order_photos">
                    <h4 style={{ color: "#66ffff" }}>Rendeléshez feltöltött képek ({orderPhotos.length})</h4>
                  </Accordion.Toggle>
                </Card.Header>
                <Accordion.Collapse eventKey="order_photos">
                  <Card.Body>
                    {orderPhotosLoading && <p style={{ color: "white" }}>Betöltés...</p>}
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                      {orderPhotoBlobUrls.map((photo, i) => (
                        <a key={i} href={photo.url} target="_blank" rel="noopener noreferrer" style={{ position: 'relative', display: 'inline-block' }}>
                          <img src={photo.url} alt={`kép ${i + 1}`} style={{ maxWidth: '120px', maxHeight: '120px', objectFit: 'contain', border: '1px solid #555', borderRadius: '4px' }} />
                          <span style={{ position: 'absolute', bottom: '2px', left: '2px', backgroundColor: 'rgba(0,0,0,0.65)', color: '#fff', fontSize: '0.7rem', padding: '1px 4px', borderRadius: '3px' }}>
                            {ORDER_PHOTO_SOURCE_LABELS[photo.source] || photo.source}
                          </span>
                        </a>
                      ))}
                    </div>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            )}
            <Card id="worksheet_card">
              <Card.Header style={{ textAlign: "center", backgroundColor: "#003399" }}>
                <Accordion.Toggle as={Button} variant="link" eventKey="1">
                  <h4 style={{ color: "#66ffff" }}>Munkalap</h4>
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey="1">
                <Card.Body>
                  {overAllAcrdActiveKey === "1" && (
                    <>
                      <div style={{ textAlign: "center" }} className="pt-2">
                        <h5 style={{ color: "aqua", textAlign: "center" }}>Munka adatok</h5>
                      </div>
                      {settings && (
                        <WorkSheetForm
                          SetTaskList={setTaskList}
                          taskList={taskList}
                          actTask={taskId}
                        />
                      )}
                      <Button key="newWmCreateBtn" variant="primary" onClick={addNewWatermeter} size="sm" className="mr-1 mb-1 py-0" disabled={isButtonDisabled}>
                        +<br />
                        Vízóra szerelés
                      </Button>
                      <Button key="newOtherCreateBtn" variant="primary" onClick={addNewOtherWork} size="sm" className="ml-1 mb-1 py-0" disabled={isButtonDisabled}>
                        +<br />
                        Egyéb munka
                      </Button>

                      <Accordion width="100%" activeKey={activeKey} onSelect={(e) => onSetActiveKey(e)}>
                        <>
                          <WmWorkListAcrdn
                            taskList={taskList}
                            wmWorkList={propState.wmWorkList}
                            SetWmWorkList={propState.SetWmWorkList}
                            actTask={taskId}
                            activeKey={activeKey}
                            setActiveKey={setActiveKey}
                            activeWmTabKey={activeWmTabKey}
                            setActiveWmTabKey={setActiveWmTabKey}
                            focusRefList={focusRefList}
                            key="wmaccrdn"
                            sealList={propState.sealList}
                            wmList={propState.wmList}
                            updateWorkAndInvoice={propState.updateWorkAndInvoice}
                            propStateListWmItem={propState.propStateListWmItem}
                          />
                          <OtherWorkListAcrdn
                            taskList={taskList}
                            otherWorkList={propState.otherWorkList}
                            SetOtherWorkList={propState.SetOtherWorkList}
                            wmWorkList={propState.wmWorkList}
                            SetWmWorkList={propState.SetWmWorkList}
                            actTask={taskId}
                            activeKey={activeKey}
                            setActiveKey={setActiveKey}
                            focusRefList={focusRefList}
                            propStateListWmItem={propState.propStateListWmItem}
                            key="otheraccrdn"
                          />
                        </>
                      </Accordion>

                      {activeKey && (
                        <div>
                          <Button key="newWmCreateBtnLow" variant="primary" onClick={addNewWatermeter} size="sm" className="mr-1 mb-1 py-0" disabled={isButtonDisabled}>
                            +<br />
                            Vízóra szerelés
                          </Button>
                          <Button key="newOtherCreateBtnLow" variant="primary" onClick={addNewOtherWork} size="sm" className="ml-1 mb-1 py-0" disabled={isButtonDisabled}>
                            +<br />
                            Egyéb munka
                          </Button>
                        </div>
                      )}
                      <br />
                      <Form.Group controlId="taskWorkplaceData">
                        <Form.Label>
                          <small style={{ color: "indigo", textAlign: "left" }}>Mérőhely szabványosítás szükségessége:</small>
                        </Form.Label>
                        <Form.Check type="checkbox"
                          label="Szabványosítás szükséges"
                          name="taskWorkplaceToBeStandardized"
                          defaultChecked={selectedTask.task_workplace_to_be_standardized}
                          disabled={isButtonDisabled}
                          ref={workplaceToBeStandardizedRef}
                        />
                        <Form.Label><small style={{ color: "indigo", textAlign: "left" }}>Átvevő ügyfél:</small></Form.Label>
                        <Form.Control
                          as="select"
                          placeholder="Átvevő ügyfél"
                          defaultValue={!selectedTask.task_takeover_customer_type ? "Nincs megadva" : // if not set, then default to Nincs megadva 
                            (selectedTask.task_takeover_customer_type !== "Tulajdonos" &&
                            selectedTask.task_takeover_customer_type !== "Meghatalmazott" &&
                            selectedTask.task_takeover_customer_type !== "Bérlő") ? "Egyéb": selectedTask.task_takeover_customer_type }
                          name="taskTakeOverCustomerType"
                          disabled={isButtonDisabled}
                          onChange={handleTakeOverCustomerTypeChange}
                          custom>
                              <option value={""}>Nincs megadva</option>
                              <option value={"Tulajdonos"}>Tulajdonos</option>
                              <option value={"Meghatalmazott"}>Meghatalmazott</option>
                              <option value={"Bérlő"}>Bérlő</option>
                              <option value={"Egyéb"}>Egyéb</option>
                          </Form.Control>
                          { selectedTask.task_takeover_customer_type &&
                            selectedTask.task_takeover_customer_type !== "Tulajdonos" &&
                            selectedTask.task_takeover_customer_type !== "Meghatalmazott" &&
                            selectedTask.task_takeover_customer_type !== "Bérlő" &&
                            (<Form.Control
                              placeholder="Egyéb"
                              defaultValue={selectedTask.task_takeover_customer_type}
                              name="taskTakeOverCustomerTypeCustom"
                              onChange={handleTakeOverCustomerTypeChange}
                              disabled={isButtonDisabled}
                            />)}
                        <Form.Label><small style={{ color: "indigo", textAlign: "left" }}>Szerelő megjegyzése az Ügyfél felé:</small></Form.Label>
                        <Form.Control
                          placeholder="Szerelő megjegyzése az Ügyfél felé"
                          defaultValue={selectedTask.task_note_mech_to_customer}
                          name="mechanicNoteToCustomer"
                          ref={mechanicNoteToCustomerRef}
                          disabled={isButtonDisabled}
                        />
                      </Form.Group>
                      {propState.actTaskState === propState.taskStateList.STARTED && (
                        <Button variant="info" onClick={() => onSaveWorkSheet(SAVE_WORKSHEET)} className="my-2" disabled={loading}>
                          <div>
                            Mentés
                            {loading && loadingTarget === SAVE_WORKSHEET && (
                              <ButtonLoader />)}
                          </div>
                        </Button>
                      )}
                    </>
                  )}
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            <Card id="ws_photo_card">
              <Card.Header style={{ textAlign: "center", backgroundColor: "#003399" }}>
                <Accordion.Toggle as={Button} variant="link" eventKey="2">
                  <h4 style={{ color: "#66ffff" }}>Munkalap lezárása </h4>
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey="2">
                <Card.Body>
                  {(propState.actTaskState === propState.taskStateList.FINISHED || propState.actTaskState === propState.taskStateList.FAILED) && (
                    <>
                      <Button className="px-2 my-2 mx-4" onClick={printWorkSheet}>
                        {" "}
                        Munkalap nyomtatás
                      </Button>
                      <Button className="px-2 my-2 mx-4" onClick={printWorkSheet80mm}>
                        {" "}
                        Munkalap nyomtatás (80mm)
                      </Button>
                    </>
                  )}
                  {overAllAcrdActiveKey === "2" && workSheetPhotoItemSerial !== null && (
                    <>
                      <Accordion className="mb-2">
                        <Card>
                          <Accordion.Toggle as={Card.Header} eventKey="0" style={{ color: "aqua", textAlign: "left", fontSize: "1rem", fontWeight: "bold", cursor: "pointer" }}>
                            Kézzel aláírt munkalap és fotó feltöltése
                          </Accordion.Toggle>
                          <Accordion.Collapse eventKey="0">
                            <Card.Body>
                              <WorkSheetPhoto
                                taskList={taskList}
                                otherWorkList={propState.otherWorkList}
                                SetOtherWorkList={propState.SetOtherWorkList}
                                actTask={taskId}
                                item={workSheetPhotoItemSerial}
                                setItem={setWorkSheetPhotoItemSerial}
                                overAllAcrdActiveKey={overAllAcrdActiveKey}
                                setOverAllAcrdActiveKey={setOverAllAcrdActiveKey}
                              />
                            </Card.Body>
                          </Accordion.Collapse>
                        </Card>
                      </Accordion>
                      <ControlButtons
                        actTaskState={propState.actTaskState}
                        SetActTaskState={(newState) => {
                          propState.SetActTaskState(newState);
                          setIsButtonDisabled(newState.key !== "STARTED");
                        }}
                        comStat={propState.comStat}
                        actTask={taskId}
                        taskList={taskList}
                        taskStateList={propState.taskStateList}
                        setOverAllAcrdActiveKey={setOverAllAcrdActiveKey}
                        onSaveWorkSheet={(buttonTargetID, onSuccess) => saveWorkSheetWithLoader(buttonTargetID, async () => await onSuccess())}
                        showOMEFileButton={false}
                        disallowOMELoad={isAnySavedWaterMeterExists || isButtonDisabled}
                        waterMeterList={propState.wmWorkList[`${taskId}`]?.wmlist}
                      />
                      {(propState.actTaskState === propState.taskStateList.FINISHED || propState.actTaskState === propState.taskStateList.FAILED) && (
                        <Button variant="info" onClick={() => saveWorkSheetWithLoader(SAVE_SIGNED_WORKSHEET, () => setOverAllAcrdActiveKey(null))} className="ml-4 mb-2" disabled={loading}>
                          <div>Aláírt munkalap rögzítése
                            {loading && loadingTarget === SAVE_SIGNED_WORKSHEET && (
                              <ButtonLoader />)}
                          </div>
                        </Button>
                      )}
                      <SignatureBrief taskList={taskList} actTask={taskId} SetComStat={propState.SetComStat} />

                      <div style={{ textAlign: "center" }} className="pt-2">
                        <h5 style={{ color: "aqua", textAlign: "center" }}>Munkalap küldése emailben</h5>
                      </div>
                      <Form>
                        <Form.Group controlId="contactEmail">
                          <Form.Label>
                            <small style={{ color: "indigo", textAlign: "left" }}>Email:</small>
                          </Form.Label>
                          <Form.Control placeholder="Email" defaultValue={addressData.contact_email} name="contactEmail" ref={emailRef} disabled={!(propState.actTaskState === propState.taskStateList.FINISHED || propState.actTaskState === propState.taskStateList.FAILED)} />
                        </Form.Group>
                        <Button variant="info" className="ml-4 mb-2" onClick={onSaveAndSendWorkSheet} disabled={!(propState.actTaskState === propState.taskStateList.FINISHED || propState.actTaskState === propState.taskStateList.FAILED) || loading}>
                          <div>Munkalap küldése emailben
                            {loading && loadingTarget === SAVE_AND_SEND_WORKSHEET && (
                              <ButtonLoader />)}
                          </div>
                        </Button>
                        <Accordion defaultActiveKey="0">
                          <Card>
                            <Accordion.Toggle as={Card.Header} eventKey="0" style={{ color: "aqua", textAlign: "left", fontSize: "1rem", fontWeight: "bold", cursor: "pointer" }}>
                              Szerelő megjegyzése a Diszpécser felé
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="0">
                              <Card.Body>
                                <Form.Group controlId="mechanicNote">
                                  <Form.Control
                                    placeholder="Szerelő megjegyzése a Diszpécser felé"
                                    defaultValue={selectedTask.task_note_mech_to_disp}
                                    name="mechanicNote"
                                    ref={mechanicNoteRef}
                                  />
                                </Form.Group>
                              </Card.Body>
                            </Accordion.Collapse>
                          </Card>
                        </Accordion>
                      </Form>

                      <Button
                        className="ml-4 mb-2 mt-2"
                        onClick={onSaveAndInvoice}
                        disabled={!(propState.actTaskState === propState.taskStateList.FINISHED || propState.actTaskState === propState.taskStateList.FAILED) || loading}
                      >
                        <div>Mentés és tovább a számlázásra
                          {loading && loadingTarget === SAVE_AND_NEXT_TO_INVOICING && (
                            <ButtonLoader />)}
                        </div>
                      </Button>
                    </>
                  )}
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            <Card id="invoice_card" onClick={InvoiceAccordionDisabled}>
              <Card.Header style={{ textAlign: "center", backgroundColor: invoiceFormValidated ? "#003399" : "red" }}>
                <Accordion.Toggle as={Button} variant="link" eventKey="3">
                  <h4 style={{ color: "#66ffff" }}>Számlázási adatok ellenőrzése</h4>
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey="3">
                <Card.Body>
                  {overAllAcrdActiveKey === "3" && (
                    <>
                      <div style={{ textAlign: "center" }} className="pt-2">
                        <h5 style={{ color: "aqua", textAlign: "center" }}>Számla adatok</h5>
                      </div>
                      <WmInvoiceForm
                        invoiceData={propState.invoiceData}
                        setInvoiceData={propState.setInvoiceData}
                        invoiceFormValidated={invoiceFormValidated}
                        setInvoiceFormValidated={setInvoiceFormValidated}
                        setOverAllAcrdActiveKey={setOverAllAcrdActiveKey}
                        actTask={taskId}
                        taskList={taskList}
                        SetTaskList={setTaskList}
                        comStat={propState.comStat}
                        SetComStat={propState.SetComStat}
                        onSave={(buttonTargetID) => saveWorkSheetWithLoader(buttonTargetID, () => setOverAllAcrdActiveKey("4"))}
                      />
                    </>
                  )}
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            <Card onClick={InvoiceAccordionDisabled}>
              <Card.Header style={{ textAlign: "center", backgroundColor: "#003399" }}>
                <Accordion.Toggle as={Button} variant="link" eventKey="4">
                  <h4 style={{ color: "#66ffff" }}>Számlázás</h4>
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey="4">
                <Card.Body>
                  {overAllAcrdActiveKey === "4" && (
                    <>
                      <div style={{ textAlign: "center" }} className="pt-2">
                        <h5 style={{ color: "aqua", textAlign: "center" }}>Számla adatok</h5>
                      </div>
                      <WmInvoiceSummary
                        addressData={addressData}
                        invoiceData={propState.invoiceData}
                        otherWorkList={propState.otherWorkList}
                        setOverAllAcrdActiveKey={setOverAllAcrdActiveKey}
                        comStat={propState.comStat}
                        SetComStat={propState.SetComStat}
                      />
                    </>
                  )}
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
        </>
      )}
    </>
  );
};
export default DetailedTask;
